import * as RadixDialog from '@radix-ui/react-dialog'
import React from 'react'
import styled from 'styled-components'

import { CloseIcon } from '@blade/ui-kit'

type Props = {
  title?: React.ReactNode
  children?: React.ReactNode
}

export const DialogHeaderFunctional = (props: Props) => {
  return (
    <Root>
      <Title>
        <TitleContent>
          {props.children ? props.children : props.title}
        </TitleContent>

        <CloseButton>
          <CloseIcon size={20} />
        </CloseButton>
      </Title>
    </Root>
  )
}

const Root = styled(RadixDialog.Title)`
  display: grid;
  align-items: center;
  position: relative;

  padding-inline: 14px;
  padding-block: 10px;
`

const Title = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
  gap: 5px;
`

const TitleContent = styled.div`
  color: var(--appearance-inv-1);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
`

const CloseButton = styled(RadixDialog.Close)`
  all: unset;
  cursor: pointer;
  box-sizing: border-box;

  color: var(--textA-8);

  &:hover {
    color: var(--text-12);
  }
`
